import { useEffect, useState } from "react";
import axios from "../axios";

export default function BotSettings() {
  const [settings, setSettings] = useState({
    ai_chatbot_enabled: 0,
    bot_mode: "hybrid",
    bot_prompt: "",
    alert_whatsapp_number: ""
  });

  const [faqs, setFaqs] = useState([]);
  const [faq, setFaq] = useState({ question: "", answer: "" });

  const loadSettings = async () => {
    try {
      const res = await axios.get("/bot-settings");
      setSettings({
        ai_chatbot_enabled: Number(res.data.ai_chatbot_enabled || 0),
        bot_mode: res.data.bot_mode || "hybrid",
        bot_prompt: res.data.bot_prompt || "",
        alert_whatsapp_number: res.data.alert_whatsapp_number || ""
      });
    } catch (err) {
      console.error("Load settings error:", err.response?.data || err.message);
    }
  };

  const loadFaqs = async () => {
    try {
      const res = await axios.get("/bot-settings/faqs");
      setFaqs(res.data || []);
    } catch (err) {
      console.error("Load FAQs error:", err.response?.data || err.message);
    }
  };

  const saveSettings = async () => {
    try {
      await axios.post("/bot-settings", settings);
      alert("Bot settings saved ✅");
    } catch (err) {
      console.error("Save settings error:", err.response?.data || err.message);
      alert("Settings save failed ❌");
    }
  };

  const addFaq = async () => {
    if (!faq.question.trim() || !faq.answer.trim()) {
      alert("Question aur Answer dono required hain");
      return;
    }

    try {
      await axios.post("/bot-settings/faqs", faq);
      setFaq({ question: "", answer: "" });
      loadFaqs();
    } catch (err) {
      console.error("Add FAQ error:", err.response?.data || err.message);
      alert("FAQ add failed ❌");
    }
  };

  const deleteFaq = async (id) => {
    if (!window.confirm("Delete this FAQ?")) return;

    try {
      await axios.delete(`/bot-settings/faqs/${id}`);
      loadFaqs();
    } catch (err) {
      console.error("Delete FAQ error:", err.response?.data || err.message);
      alert("FAQ delete failed ❌");
    }
  };

  useEffect(() => {
    loadSettings();
    loadFaqs();
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">AI Chatbot Settings</h1>

      <div className="bg-white rounded shadow p-5 mt-5">
        <label className="flex items-center gap-3 font-semibold">
          <input
            type="checkbox"
            checked={Number(settings.ai_chatbot_enabled) === 1}
            onChange={(e) =>
              setSettings({
                ...settings,
                ai_chatbot_enabled: e.target.checked ? 1 : 0
              })
            }
          />
          Enable AI Chatbot
        </label>

        <div className="mt-4">
          <label className="font-semibold">Bot Mode</label>
          <select
            value={settings.bot_mode}
            onChange={(e) =>
              setSettings({ ...settings, bot_mode: e.target.value })
            }
            className="border rounded px-3 py-2 w-full mt-1"
          >
            <option value="hybrid">Hybrid - FAQ + AI</option>
            <option value="faq">Only FAQ</option>
            <option value="ai">Only AI Prompt</option>
          </select>
        </div>

        <div className="mt-4">
          <label className="font-semibold">AI Prompt</label>
          <textarea
            value={settings.bot_prompt}
            onChange={(e) =>
              setSettings({ ...settings, bot_prompt: e.target.value })
            }
            rows="6"
            className="border rounded px-3 py-2 w-full mt-1"
            placeholder="Example: You are assistant for hair transplant clinic. Reply in Hindi. Ask customer name, city, hair loss stage and appointment date."
          />
          <div className="mt-4">
          <label className="font-semibold">Appointment Alert WhatsApp Number</label>
          <input
            value={settings.alert_whatsapp_number}
            onChange={(e) =>
              setSettings({
                ...settings,
                alert_whatsapp_number: e.target.value
              })
            }
            className="border rounded px-3 py-2 w-full mt-1"
            placeholder="Example: 917827789105"
          />
          <p className="text-xs text-gray-500 mt-1">
            Jab lead Booked hogi to alert is number par jayega.
          </p>
        </div>
        </div>

        <button
          onClick={saveSettings}
          className="bg-blue-600 text-white px-5 py-2 rounded mt-4"
        >
          Save Settings
        </button>
      </div>

      <div className="bg-white rounded shadow p-5 mt-6">
        <h2 className="text-xl font-bold mb-4">Custom Questions / Answers</h2>

        <input
          value={faq.question}
          onChange={(e) => setFaq({ ...faq, question: e.target.value })}
          className="border rounded px-3 py-2 w-full mb-3"
          placeholder="Question example: hair transplant price kya hai?"
        />

        <textarea
          value={faq.answer}
          onChange={(e) => setFaq({ ...faq, answer: e.target.value })}
          className="border rounded px-3 py-2 w-full mb-3"
          rows="4"
          placeholder="Answer example: Hair transplant ka price grafts ke according hota hai. Consultation ke liye apna naam aur city bhej dijiye."
        />

        <button
          onClick={addFaq}
          className="bg-green-600 text-white px-5 py-2 rounded"
        >
          Add FAQ
        </button>

        <div className="mt-5">
          {faqs.map((item) => (
            <div
              key={item.id}
              className="border rounded p-3 mb-3 flex justify-between gap-4"
            >
              <div>
                <div className="font-semibold">{item.question}</div>
                <div className="text-gray-600 text-sm mt-1">
                  {item.answer}
                </div>
              </div>

              <button
                onClick={() => deleteFaq(item.id)}
                className="text-red-600 font-semibold"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}